import { CapoPlugin } from "/vercel/path0/v3/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];